import { Link } from "src/components/TextV2/Link.tsx";
import * as React from "react";
import { type State } from "src/components/DropZoneInputV2/types.ts";
import * as styles from "./InvalidMediaErrors.style.ts";
import { useTranslation } from "react-i18next";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";

export const InvalidMediaErrors = ({
  onClear,
  invalidMedia,
  media,
  maxItems,
}: {
  onClear: () => void;
  invalidMedia: State["invalidMedia"];
  media: State["media"];
  maxItems?: number;
}) => {
  const { t } = useTranslation(
    TranslationNamespaceEnum.DropZoneInputComponentV2,
  );
  const maxItemsUploaded = !!maxItems && maxItems <= media.length;

  return (
    <div
      css={styles.root({
        maxItemsUploaded,
      })}
    >
      <div>
        {invalidMedia.map((media, index) => (
          <div key={index}>
            <b>{media.attributes.name}</b>: <span>{media.errors[0]}</span>
          </div>
        ))}
      </div>
      <div>
        <Link onClick={onClear}>{t("clearErrors")}</Link>
      </div>
    </div>
  );
};
